import WebSocket from 'ws';
import { sendWsMessage } from '../connection/create-ws-bridge.js';
import { callSkill } from './index.js';
import type { LogFn } from '../log.js';

export interface SkillCallMessage {
  id?: string;
  skillId: string;
  operationId: string;
  params?: Record<string, unknown>;
}

export function handleSkillCall(msg: SkillCallMessage, socket: WebSocket, log: LogFn): void {
  callSkill(msg.skillId, msg.operationId, msg.params ?? {})
    .then((result) => {
      sendWsMessage(socket, { type: 'skill_result', id: msg.id, result });
    })
    .catch((err) => {
      sendWsMessage(socket, { type: 'skill_result', id: msg.id, error: String(err) });
      log(`[Bridge service] Skill invocation failed (${msg.skillId}/${msg.operationId}): ${err}`);
    });
}
